import { Service } from '@/types/services';
import { aiAutomationServices, softwareTechServices, creativeServices, seoAnalyticsServices, aiWorkflowServices, buildRescueServices } from './combinedServices';
import { architectureServices } from './categories/architecture';

export const services: Service[] = [
  ...architectureServices,
  ...aiAutomationServices,
  ...softwareTechServices,
  ...creativeServices,
  ...seoAnalyticsServices,
  ...aiWorkflowServices,
  ...buildRescueServices,
];

export const getServiceById = (id: string): Service | undefined => {
  return services.find(service => service.id === id);
};

export const getServicesByCategory = (category: string): Service[] => {
  return services.filter(service => service.category === category);
};
